import React, { Component } from 'react';
import { Form, Icon, Input, Row, Col } from 'antd';
import * as formUtils from 'utils/formUtils';
import { GenericCaptchaForm } from '@bit/ui-common.ui-components/ss-common-data'

const
{ FORM } = formUtils,
{
    USER_ID,
    CAPTCHA
} = FORM.TYPES,
FormItem = Form.Item;

export default Form.create()(
    class ForgotForm extends Component {
        constructor(props) {
            super(props);
            this.getProps = {};

            for(var p in formUtils.getProps.login)
                this.getProps[p] = formUtils.getProps.login[p].bind(this);

            this.getComponentState = formUtils.getComponentState.bind(this);
            this.setFieldState = formUtils.setFieldState.bind(this);
            this.onUpdate = formUtils.onUpdate.bind(this);
            this.setField = formUtils.setField.bind(this);
            this.state = formUtils.getComponentState();
        }

        render() {
            const
            { username } = this.getProps,
            { state } = this.props;

            return (
                <div>
                    <Form>
                        <Row>
                            <Col>
                                <FormItem {...state[USER_ID].form} style={{ marginBottom: '16px' }}>
                                    <Input id='Login-ForgotForm-UserID' {...username(USER_ID, 'User ID / Email', (<Icon type="user" style={{ color: 'rgba(0,0,0,.75)' }} />))}/>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <GenericCaptchaForm {...this.props}/>
                            </Col>
                        </Row>
                    </Form>
                </div>
            )
        }
    }
);
